import React, { Component } from 'react'
import Button from 'react-bootstrap/Button'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import ReactPlayer from 'react-player'

import './VideoAgreement.css'

class VideoAgreement extends Component {
  constructor(props) {
    super(props)

    this.state = {
      played: false,
    }
  }

  confirmRequirement() {
    if (!this.props.onAgree) {
      return;
    }
    this.props.onAgree()
  }

  render() {
    const { requirement, confirmed } = this.props
    return <div className='VideoAgreementRoot'>
      <div className='VideoAgreementPlayerContainer'>
        <ReactPlayer
          data-test-video-agreement-player
          className='VideoAgreementPlayer'
          url={requirement.src}
          controls={true}
          onPlay={() => this.setState({ played: true, })}
          width='100%'
          height='100%'
        />
      </div>
      <div className='VideoAgreementControls'>
        {confirmed && <div className='VideoAgreementAgreed'>
            確認済みです。
          </div>}
        {!confirmed && <Row className='VideoAgreementControlsRow'>
            <Col sm={10}>
              動画を確認したら、「確認した」ボタンを押してください。
            </Col>
            <Col sm='auto'>
              <Button
                data-test-video-agreement-confirm
                variant='success'
                disabled={!this.state.played}
                onClick={() => this.confirmRequirement()}
              >
                確認した
              </Button>
            </Col>
          </Row>}
      </div>
    </div>
  }
}

export default VideoAgreement;
